import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../index.css";

import { Button, DropDownField, TextAreaField } from "../../../helpers";
import { addTicket } from '../../../services/api/tickets'
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { updateInvoiceData } from "../../../services/redux/reducers/invoiceBooking/invoiceBooking";
import { fetchTicketSubCategory } from "../../../services/redux/reducers/commonThunk";
import { getPurchaseInVoiceBookingTicketFollowers } from "../../../services/api/invoiceBooking";

import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";
import { updateSellerPIPunchVerificationStatus } from "../../../services/api/sellerPIPunch";


const RaiseTicketModal = (props) => {
    const { selectedRow , setIsLoading, setIsRaiseTicketVisible, sellerPIPunch} = props

    const userDetails = useSelector(state => state.userDetails)
    let listInvoiceData = useSelector(state => state.invoiceBookingPIWise.listInvoiceData)
    let ticketSubCategoies = useSelector(state => state.common.ticketSubCategories || [])

    const userId = userDetails.userId
    const [selectedTitle, setSelectedTitle] = useState("")
    const [selectedSubcategoryId, setSelectedSubcategoryId] = useState(null)
    const [ticketDesc, setTicketDesc] = useState("")
    const [ticketFollowers, setTicketFollowers] = useState([])
    const [emailAlert, setEmailAlert] = useState(false)
    const dispatch = useDispatch();
    // let sellerPIPunch = listInvoiceData.data

    const categoryId = 6 // hard coded for "PI Issue" ticket category
    useEffect(()=> {
        dispatch(fetchTicketSubCategory(true))
        getTicketFollower()
    }, [])
    useEffect(()=>{
        const pmCompanyConfig = getPMCompanyConfig(selectedRow.pmCompanyId)
        const docLink = `${pmCompanyConfig.portalLink}/sellerpo/${selectedRow.sellerPOId}`
        const initialDescription = `PO: ${docLink} \nPI Details: ${selectedRow.sellerPINumber} (${selectedRow.PIDocNo}). \n`
        setTicketDesc(initialDescription)

    },[selectedTitle])

    const filteredSubCategories = ticketSubCategoies.filter(subCategory => subCategory.pageRef === "INVOICE_BOOKING");
    const handleOptionChange = (e) => {
        setSelectedSubcategoryId(e.target.value);
        const relatedSubCategory = filteredSubCategories.find(category => category.ticketSubcategoryId === e.target.value);
        setSelectedTitle(relatedSubCategory.subcategoryName);
        setEmailAlert(relatedSubCategory.emailAlerts)
    };
    const handleInputChange = (e) => {
        setTicketDesc(e.target.value);
    };

    const getTicketFollower = async ()=>{
        const data = {
            userId : selectedRow.createdBy,
            docNo : selectedRow.PIDocNo
        }
        const ticketFollowerRes = await getPurchaseInVoiceBookingTicketFollowers(data)
        if(ticketFollowerRes.data){
            const ticketFollowerIds =  ticketFollowerRes.data.map(each => each.userId)
            setTicketFollowers(ticketFollowerIds)
        }
    }

    const handleSubmit = async () => {
        if(!selectedSubcategoryId){
            return dispatch(raiseToast({severity:'warn', summary: 'Raise Ticket', detail: 'Please select a reason', life: 3000}))
        }
        else{
            const ticketObj = {
                ticketAssignee: selectedRow.createdBy,
                ticketCategoryId: categoryId,
                ticketCreatedBy: userId,
                ticketDescription: ticketDesc,
                ticketDocument: "",
                ticketDueDate: new Date((new Date()).getTime() + 2 * 24 * 60 * 60 * 1000),
                ticketName: `${selectedTitle}-${selectedRow.sellerPODocNo}`,
                ticketPriority: "MEDIUM",
                ticketSubcategoryId: selectedSubcategoryId,
                pIDocNo: selectedRow.PIDocNo,
                ticketFollower : ticketFollowers,
                ticketEmailAlerts: emailAlert,
                docNo: selectedRow.PIDocNo
            }
            if(ticketDesc === ""){
                return dispatch(raiseToast({severity:'warn', summary: 'Add Ticket', detail: "Ticket description can't be empty", life: 3000}))
            }

            setIsLoading(true)
            const res = await addTicket(ticketObj)
            if(res.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'Error in Adding Ticket', detail: res.data.error, life: 3000}))
            }else{
                let updatedSellerPIPunch = [...sellerPIPunch]
                if(selectedRow.verifiedBy){
                    const updatedVerifiedSellerPIPunchRes = await updateSellerPIPunchVerificationStatus({sellerPIPunchId: selectedRow.sellerPIPunchId, isVerified: false})
                    if(updatedVerifiedSellerPIPunchRes.failure){
                        dispatch(raiseToast({severity:'error', summary: 'PI Verification', detail: updatedVerifiedSellerPIPunchRes.data.error, life: 3000}))
                    }
                    updatedSellerPIPunch = sellerPIPunch.map(eachSellerPIPunch => {
                        if(eachSellerPIPunch.sellerPIPunchId === selectedRow.sellerPIPunchId){
                            return {...eachSellerPIPunch, verifiedBy: updatedVerifiedSellerPIPunchRes.data.verifiedBy, verifiedAt: updatedVerifiedSellerPIPunchRes.data.verifiedAt}
                        }
                        return {...eachSellerPIPunch}
                    })
                }

                const ticketDetails = res.data.data
                updatedSellerPIPunch = updatedSellerPIPunch.map((each) =>{
                    if(each.sellerPIPunchId == selectedRow.sellerPIPunchId){
                        let tickets = selectedRow.tickets ? [...selectedRow.tickets] : []
                        let newTicket = {
                            'ticketId': ticketDetails.ticketId,
                            'ticketStatusId': ticketDetails.ticketStatusId,
                            'docNo': ticketDetails.docNo,
                            'createdBy': ticketDetails.createdBy
                        }
                        tickets.push(newTicket)
                        return {
                            ...each, 
                            tickets: tickets
                        }
                    }
                    else{
                        return { ...each }
                    }
                })
                dispatch(updateInvoiceData({...listInvoiceData, data: updatedSellerPIPunch}))
                setIsRaiseTicketVisible(false)
                setIsLoading(false)
                return dispatch(raiseToast({severity:'success', summary: 'Ticket Raised', detail: 'An email has been sent to KAM Successfully.', life: 3000}))
            }

        }
    };

    return (
        <div className="flex flex-column pb-2 mb-2">
            <DropDownField labelText="Select reason" value={selectedSubcategoryId} options={filteredSubCategories} optionLabel="subcategoryName" optionValue="ticketSubcategoryId" onChange={handleOptionChange} required/>
            <div className="flex flex-column pb-2 mt-5">
                {selectedTitle && (
                    <>
                        <TextAreaField
                            labelText="Description"
                            value={ticketDesc}
                            rows={10}
                            onChange={handleInputChange}
                            maxLength={1000}
                            required
                        />
                        <p><b>Note*:</b> Please don't change auto-generated description. You can add additional description below.</p>
                    </>
                )}
            </div>
            <div className="flex flex-row justify-content-end mt-5">
                <Button className="mt-5" label="Raise Ticket" onClick={handleSubmit} />
            </div>
            
        </div>
    );
};

export default RaiseTicketModal;

